import { render, staticRenderFns } from "./DialogCongratulationsSetup.vue?vue&type=template&id=4121540a&scoped=true"
import script from "./DialogCongratulationsSetup.vue?vue&type=script&lang=js"
export * from "./DialogCongratulationsSetup.vue?vue&type=script&lang=js"
import style0 from "./DialogCongratulationsSetup.vue?vue&type=style&index=0&id=4121540a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4121540a",
  null
  
)

export default component.exports